// src/components/WidgetSelection.js
import React, { useState, useEffect } from 'react';
import { Checkbox, FormControlLabel, Button, Box, Menu, MenuItem } from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';

const WidgetSelection = ({ availableWidgets, onWidgetSelectionChange }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedWidgets, setSelectedWidgets] = useState(() => {
    const storedSelections = localStorage.getItem('selectedWidgets');
    return storedSelections ? JSON.parse(storedSelections) : {};
  });

  useEffect(() => {
    let updatedSelection = localStorage.getItem("selectedWidgets")
      ? JSON.parse(localStorage.getItem("selectedWidgets"))
      : null;

    //  Select all widgets by default if none are selected
    if (!updatedSelection || Object.values(updatedSelection).every((isSelected) => !isSelected)) {
      updatedSelection = Object.fromEntries(availableWidgets.map((widget) => [widget.name, true]));
    }
    if (
      updatedSelection.issuesSeverity === false &&
      updatedSelection.projectSummary === false &&
      updatedSelection.projectStatus === false
    ) {
      updatedSelection = {
        ...updatedSelection,
        issuesSeverity: true,
        projectSummary: true,
        projectStatus: true,
      };
    }

    setSelectedWidgets(updatedSelection);
    localStorage.setItem("selectedWidgets", JSON.stringify(updatedSelection));
    onWidgetSelectionChange(updatedSelection);
  }, [availableWidgets]);

  const toggleWidget = (widgetName) => {
    setSelectedWidgets((prev) => {
      let updatedSelection = { ...prev, [widgetName]: !prev[widgetName] };

      // If all three widgets are false, reset them to true
      if (
        updatedSelection.issuesSeverity === false &&
        updatedSelection.projectSummary === false &&
        updatedSelection.projectStatus === false
      ) {
        updatedSelection = {
          ...updatedSelection,
          issuesSeverity: true,
          projectSummary: true,
          projectStatus: true,
        };
      }

      localStorage.setItem("selectedWidgets", JSON.stringify(updatedSelection));
      onWidgetSelectionChange(updatedSelection);
      return updatedSelection;
    });
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      {/* Widget Selection Button */}
      <Button
        variant="outlined"
        onClick={handleMenuOpen}
        endIcon={anchorEl ? <ExpandLess /> : <ExpandMore />}
        sx={{
          // textTransform: 'none',
          '&:hover': {
            backgroundColor: 'rgb(12, 26, 50)',
            color: '#fff',
          },
        }}
      >
        Select Widgets
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          style: { width: 'auto', padding: '10px', overflow: 'visible' }
        }}

      >
        {availableWidgets.map((widget, index) => (
          <MenuItem key={index} dense>
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectedWidgets[widget.name] || false}
                  onChange={() => toggleWidget(widget.name)}
                />
              }
              label={widget.label}
            />
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default WidgetSelection;
